module.exports = __webpack_public_path__ + "static/media/Bedroom3-1.8db8f503.jpg";